module.exports = __webpack_public_path__ + "static/media/locol-01.b282249b.b55e6025.af59a6a0.png";